function renderSliderSectionFromSettings(container, settings) {
  const sectionId = `slider-${Math.random().toString(36).substring(2, 8)}`;
  const wrapper = document.createElement('div');
  wrapper.className = `split-wrapper-${sectionId} ${settings.layout_mode}`;
  wrapper.style.display = 'flex';
  wrapper.style.flexWrap = 'wrap';
  wrapper.style.alignItems = 'stretch';
  wrapper.style.width = `${settings.section_width}%`;
  wrapper.style.maxWidth = `${settings.section_max_width}px`;
  wrapper.style.margin = '0 auto';
  wrapper.style.border = '1px solid #eee';
  wrapper.style.borderRadius = '16px';
  wrapper.style.overflow = 'hidden';

  const [vAlign, hAlign] = settings.image_text_alignment.split(' ');

  const style = document.createElement('style');
  style.innerHTML = `
    .text-content{
      text-align:left
    }
    .text-content ul{
      padding:0 0 !important
    }
    .split-wrapper-${sectionId}.image-right .carousel-side-${sectionId} {
      order: 2;
    }
    .split-wrapper-${sectionId}.image-right .text-side {
      order: 1;
    }
    @media screen and (max-width: 768px) {
      .split-wrapper-${sectionId} {
        flex-direction: column !important;
      }
      .carousel-side-${sectionId},
      .text-side {
        flex: 1 1 100%;
        order: initial !important;
      }
      .carousel-${sectionId} {
        min-height: ${settings.section_min_height_mobile}px !important;
      }
    }
  `;
  document.head.appendChild(style);

  const imageSide = document.createElement('div');
  imageSide.className = `carousel-side-${sectionId}`;
  imageSide.style.flex = '1 1 50%';
  imageSide.style.position = 'relative';
  imageSide.style.overflow = 'hidden';
  imageSide.style.color = 'white';

  const carousel = document.createElement('div');
  carousel.className = `carousel-${sectionId}`;
  carousel.style.width = '100%';
  carousel.style.height = '100%';
  carousel.style.position = 'relative';
  carousel.style.minHeight = `${settings.section_min_height}px`;

  const overlay = document.createElement('div');
  overlay.className = `text-overlay text-overlay--v-${vAlign} text-overlay--h-${hAlign}`;
  overlay.style.position = 'absolute';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.display = 'flex';
  overlay.style.alignItems = verticalAlignCSS(vAlign);
  overlay.style.justifyContent = horizontalAlignCSS(hAlign);
  overlay.style.padding = '20px';
  overlay.style.zIndex = 10;
  overlay.style.pointerEvents = 'none';

  const overlayInner = document.createElement('div');
  overlayInner.className = 'text-overlay__inner';
  overlayInner.style.pointerEvents = 'auto';
  overlayInner.style.maxWidth = '90%';

  let html = '';
  if (settings.image_title) html += `<h2 class="text-overlay__title h1">${settings.image_title}</h2>`;
  if (settings.image_content) html += `<div class="text-overlay__rte">${settings.image_content}</div>`;
  if (settings.image_button_text)
    html += `<a href="${settings.image_button_link}" class="btn btn--${settings.image_button_style}" style="margin-top: 12px; display: inline-block;">${settings.image_button_text}</a>`;

  overlayInner.innerHTML = html;
  overlay.appendChild(overlayInner);

  settings.images.forEach((url, index) => {
    const item = document.createElement('div');
    item.className = `carousel-item-${sectionId}`;
    item.style.backgroundImage = `url(${url})`;
    item.style.backgroundSize = 'cover';
    item.style.backgroundPosition = 'center';
    item.style.position = 'absolute';
    item.style.width = '100%';
    item.style.height = '100%';
    item.style.top = '0';
    item.style.left = '0';
    item.style.opacity = index === 0 ? '1' : '0';
    item.style.transition = 'all 1s ease';
    carousel.appendChild(item);
  });

  imageSide.appendChild(overlay);
  imageSide.appendChild(carousel);

  const textSide = document.createElement('div');
  textSide.className = 'text-side';
  textSide.style.flex = '1 1 50%';
  textSide.style.padding = '30px';
  textSide.style.display = 'flex';
  textSide.style.flexDirection = 'column';
  textSide.style.justifyContent = 'center';

  const textAlign = settings.text_alignment || 'center';
  const textWrapper = document.createElement('div');
  textWrapper.className = `align-ltr-${textAlign}`;

  if (settings.text_title)
    textWrapper.innerHTML += `<h2 style="margin-bottom: 12px;">${settings.text_title}</h2>`;
  if (settings.text_content)
    textWrapper.innerHTML += `<div class="text-content markdown-body" style="margin-bottom: 16px;">${marked.parse(settings.text_content)}</div>`;
  if (settings.text_button_text)
    textWrapper.innerHTML += `<a href="${settings.text_button_link}" class="btn btn--${settings.text_button_style}">${settings.text_button_text}</a>`;

  textSide.appendChild(textWrapper);
  wrapper.appendChild(imageSide);
  wrapper.appendChild(textSide);

  container.appendChild(wrapper);

  const items = carousel.querySelectorAll(`.carousel-item-${sectionId}`);
  let current = 0;
  setInterval(() => {
    items[current].style.opacity = '0';
    current = (current + 1) % items.length;
    items[current].style.opacity = '1';
  }, settings.carousel_interval * 1000);

  function verticalAlignCSS(value) {
    if (value === 'top') return 'flex-start';
    if (value === 'bottom') return 'flex-end';
    return 'center';
  }

  function horizontalAlignCSS(value) {
    if (value === 'left') return 'flex-start';
    if (value === 'right') return 'flex-end';
    return 'center';
  }
}
